export default __webpack_public_path__ + "static/media/auto-miles.955e0f70.svg";